export default "__VITE_ASSET__75a67baf__"